<template>
    <div v-frag>
        <CardIeaAppMain>

            <div style="padding-left:15px; padding-top: 20px; padding-bottom: 20px; display: flex;">
                ¿Ya estás preinscrito? Notifica tu pago
                <router-link to="/recuperar-inscripcion"><strong>Aquí</strong></router-link>
                <div class="text-center" style="margin-left: 5px;">

                    <v-dialog v-model="dialog" width="500">



                        <v-card>

                            <v-card-title class="text-h5 grey lighten-2">
                                Notificar Pago
                            </v-card-title>

                            <v-card-text>
                                <v-form v-if="first_step" ref="form" v-model="valid" lazy-validation>

                                    <div style="font-size: 16px; margin-top:30px;">
                                        Tipo de documento
                                    </div>

                                    <v-radio-group v-model="documentType" row>
                                        <v-radio label="DNI" value="1"></v-radio>
                                        <v-radio label="Pasaporte" value="2"></v-radio>
                                    </v-radio-group>

                                    <v-text-field v-model="dniPre" label="N° de documento" required
                                        placeholder="00000000"></v-text-field>

                                    <v-text-field v-model="emailPre" label="E-mail" required>
                                    </v-text-field>

                                    <v-select :items="items" item-text="name" item-value="value"
                                        label="Plataforma de pago" v-model="plataformaPre"></v-select>

                                    <v-text-field v-model="codigo_confirmacion" label="Código de confirmación" required>
                                    </v-text-field>
                                </v-form>

                                <div v-else style="font-size: 16px; margin-top:30px;">
                                    {{ paymentMessage }}
                                </div>
                            </v-card-text>

                            <v-divider></v-divider>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn v-if="first_step" color="primary" rounded dark
                                    @click="dialog = false; notificar();">
                                    Notificar
                                </v-btn>
                                <v-btn rounded dark @click="dialog = false; first_step = true;">
                                    Cerrar
                                </v-btn>
                            </v-card-actions>

                        </v-card>

                    </v-dialog>
                </div>
            </div>

            <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                <CardIeaApp colorCard="#2D3436" title="Pre - Inscripción">
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-row align="center">
                            <v-col v-for="(item, index) in inputs" :key="index" :cols="item.config.cols"
                                :xs="item.config.xs" :sm="item.config.sm" :md="item.config.md" :lg="item.config.lg"
                                :xl="item.config.xl">
                                <InputCustom :inputProp="item" v-on:change="item => {
                                        changed(item);
                                    }
                                    " />
                            </v-col>
                        </v-row>
                    </v-form>
                    <!-- <div v-if="inputs[9].value != null && inputs[9].value != 'No aplica'"
                        style="margin-bottom: 10px; display:inline">
                        <v-alert type="info">Las suscripciones solo podrán ser realizadas con tarjeta de
                            crédito</v-alert>
                    </div> -->
                </CardIeaApp>
            </v-col>


            <!-- <v-row> -->
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <v-btn @click="store()" block x-large class="white--text rounded-lg font-weight-regular" depressed
                    color="btnSuccess" :disabled="!valid" :loading="loader">Aceptar</v-btn>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <div :key="componentKey" id="error" style="display:none">
                    <v-alert type="error">No es posible realizar esa acción. Por favor escribinos desde <a :href="soporteUrl" target="_blank">nuestra página de contacto</a>.</v-alert>
                </div>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            </v-col>
            <!-- <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <v-btn
              @click="cancel()"
              block
              large
              class="white--text"
              depressed
              color="btnCancel"
              >Cancelar</v-btn
            >
          </v-col> -->
            <!-- </v-row> -->
            <br /><br /><br /><br /><br />
            <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6"></v-col>
        </CardIeaAppMain>

        <DebugModal :data="$data" />

    </div>
</template>
 
<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";
import CardIeaApp from "../../components/CardIeaApp";

import DebugModal from "../../components/DebugModal";
import MessagesRules from "../../config/MessagesRules";
// import Form from "../../5r41/Form";
import InputCustom from "../../components/InputCustom";
var v = {
    name: "PreInscripcionnuevaversion",
    components: {
        CardIeaAppMain,
        CardIeaApp,
        DebugModal,
        InputCustom
    },
    mounted() {
        console.log('llemogadsdsfds')
        this.loadInitial();
    },
    computed: {
        soporteUrl: () => process.env.VUE_APP_SOPORTE_URL,
        loader() {
            return this.$store.getters.loader;
        }
    },
    data: () => ({
        valid: true,
        loading: false,
        componentKey: 0,
        first_step: true,
        paymentMessage: "",
        items: [
            { name: 'Mercadopago', value: "Mercadopago" },
            { name: 'PayPal', value: 'PayPal' },
            { name: 'Rapipago', value: 'Rapipago' },
        ],
        inputs: [
            {
                tag: "nombre",
                text: "Nombre",
                placeholder: "Nombre",
                icon: "mdi-account",
                required: true,
                value: "",
                type: "text",
                rules: [v => !!v || "Nombre" + MessagesRules.required],
                counter: 0,
                config: {
                    cols: 12,
                    xs: 12,
                    sm: 12,
                    md: 6,
                    lg: 6,
                    xl: 6
                }
            },
            {
                tag: "apellido",
                text: "Apellido",
                placeholder: "Apellido",
                icon: "mdi-account",
                required: true,
                value: "",
                type: "text",
                rules: [v => !!v || "Apellido" + MessagesRules.required],
                counter: 0,
                config: {
                    cols: 12,
                    xs: 12,
                    sm: 12,
                    md: 6,
                    lg: 6,
                    xl: 6
                }
            },
            {
                tag: "area",
                text: "Área Celular - móvil",
                placeholder: "####",
                icon: "mdi-cellphone",
                required: true,
                value: "",
                type: "text",
                mask: "####",
                rules: [v => !!v || "Área Celular - móvil" + MessagesRules.required],
                counter: 0,
                config: {
                    cols: 12,
                    xs: 12,
                    sm: 12,
                    md: 6,
                    lg: 6,
                    xl: 6
                }
            },
            {
                tag: "telefono",
                text: "Celular - móvil (Sin 15)",
                placeholder: "########",
                icon: "mdi-cellphone",
                required: true,
                value: "",
                type: "text",
                mask: "########",
                rules: [v => !!v || "Celular - móvil" + MessagesRules.required],
                counter: 0,
                config: {
                    cols: 12,
                    xs: 12,
                    sm: 12,
                    md: 6,
                    lg: 6,
                    xl: 6
                }
            },
            {
                tag: "typeDoc",
                text: "Tipo de documento",
                placeholder: "",
                icon: "",
                value: 1,
                type: "radio",
                rules: [v => !!v || "N° de documento" + MessagesRules.required],
                data: [
                    { text: "DNI", value: 1 },
                    { text: "Pasaporte", value: 2 }
                ],
                config: {
                    cols: 12,
                    xs: 12,
                    sm: 12,
                    md: 12,
                    lg: 12,
                    xl: 12
                }
            },
            {
                tag: "doc",
                text: "N° de documento",
                placeholder: "00000000",
                icon: "mdi-card-account-details",
                required: true,
                value: "",
                type: "DNI",
                mask: "NNNNNNNN",
                rules: [v => !!v || "N° de documento" + MessagesRules.required],
                counter: 0,
                config: {
                    cols: 12,
                    xs: 12,
                    sm: 12,
                    md: 12,
                    lg: 12,
                    xl: 12
                }
            },
            {
                tag: "email",
                text: "Email",
                placeholder: "ejemplo@ejemplo.com",
                icon: "mdi-email",
                required: true,
                value: "",
                type: "email",
                rules: [
                    v => !!v || "Email" + MessagesRules.required,
                    v => /.+@.+\..+/.test(v) || MessagesRules.email
                ],
                counter: 0,
                config: {
                    cols: 12,
                    xs: 12,
                    sm: 12,
                    md: 12,
                    lg: 12,
                    xl: 12
                }
            },
            {
                tag: "sede_id",
                text: "Sede de interés",
                placeholder: "Seleccionar",
                icon: "mdi-map-marker",
                value: "",
                required: true,
                readonly: false,
                type: "autocomplete",
                rules: [v => !!v || "Sede de interes" + MessagesRules.required],
                data: [],
                ssr: {
                    active: false
                },
                config: {
                    cols: 12,
                    xs: 12,
                    sm: 12,
                    md: 12,
                    lg: 12,
                    xl: 12
                },
                onchange: true
            },
            {
                tag: "curso_id",
                text: "Curso de interés",
                placeholder: "Seleccionar",
                icon: "mdi-clipboard-text",
                value: "",
                required: true,
                readonly: false,
                type: "autocomplete",
                rules: [v => !!v || "Curso de interes" + MessagesRules.required],
                data: [],
                ssr: {
                    active: false
                },
                config: {
                    cols: 12,
                    xs: 12,
                    sm: 12,
                    md: 12,
                    lg: 12,
                    xl: 12
                },
            }
            // ,
            // {
            //     tag: "mesInicio",
            //     text: "Inicia en",
            //     placeholder: "",
            //     icon: "mdi-calendar",
            //     // value: 1,
            //     required: true,
            //     type: "select",
            //     rules: [v => !!v || "Inicia en" + MessagesRules.required],
            //     data: [
            //         // { text: "Enero",      value: 1 },
            //         // { text: "Febrero",    value: 2 },
            //         // { text: "Marzo",      value: 3 },
            //         // { text: "Abril",      value: 4 },
            //         // { text: "Mayo",       value: 5 },
            //         // { text: "Junio",      value: 6 },
            //         // { text: "Julio",      value: 7 },
            //         // { text: "Agosto",     value: 8 },
            //         // { text: "Septiembre", value: 9 },
            //         // { text: "Octubre",    value: 10 },
            //         // { text: "Noviembre",  value: 11 },
            //         // { text: "Diciembre",  value: 12 }
            //     ],
            //     config: {
            //         cols: 12,
            //         xs: 12,
            //         sm: 12,
            //         md: 12,
            //         lg: 12,
            //         xl: 12
            //     }
            // },
        ],
        documentType: null,
        dniPre: null,
        emailPre: null,
        plataformaPre: null,
        codigo_confirmacion: null,
        dialog: false,
    }),
    methods: {
        store() {
            document.getElementById('error').style.display = "none";
            this.loading = true;

            if (this.$refs.form.validate()) {
                this.inputs[10] = {
                    tag: "circuito_id",
                    value: this.$route.params.id
                };

                this.$API
                    .post({
                        url: "circuito/preinscipcion",
                        data: this.inputs,
                        form: true
                    }) 
                    .then(res => {
                        //si no se requiere pago, redirect to inscripcion
                        if (res.id)
                            this.$router.replace({ name: "CircuitoPago", params: { id: this.$route.params.id, idML: res.SecretKeyML } });
                        else
                            location.replace(res.redirect_to);

                        /*this.$store.dispatch("preinscrito", res.SecretKeyML);
                        setTimeout(() => {
                          this.$router.replace({ name: "CircuitoPago", params:{id:this.$route.params.id, idML:res.SecretKeyML} });
                        }, 2000);
                        */
                    })
                    .catch(() => {
                        this.loading = false;
                        document.getElementById('error').style.display = "inline";
                        window.scrollTo(0, document.body.scrollHeight);
                    });
            } else {
                this.loading = false;
            }
        },
        changed(item) {
            // && item.onchange
            if (item.tag == "sede_id") {
                this.$API
                    .get({
                        url: "cursos-circuitos/" + item.value,
                        data: {}
                    })
                    .then(res => {
                        this.inputs[8].data = res;
                    });
            }
        },
        forceRerender() {
            this.componentKey += 1;
        },
        async cursosDeSede(sede) {
            const cursos = await this.$API.get({ url: "cursos-circuitos/" + sede, data: {} });
            return Array.isArray(cursos) ? cursos : [];
        },
        // #345: `?curso=<id>` (lo manda cetae.com.ar) elige sede y curso si el curso está
        // habilitado; si no, se ignora. Con una sola sede ofrecida, viene elegida.
        async preseleccionar(sedes) {
            const curso = parseInt(this.$route.query.curso);
            const candidatas = this.inputs[7].value ? [this.inputs[7].value] : sedes.map(s => s.value);

            if (curso) {
                for (const sede of candidatas) {
                    const cursos = await this.cursosDeSede(sede);
                    const elegido = cursos.find(c => parseInt(c.value) === curso);
                    if (elegido) {
                        this.inputs[7].value = sede;
                        this.inputs[8].data = cursos;
                        this.inputs[8].value = elegido.value;
                        return;
                    }
                }
            }

            if (!this.inputs[7].value && sedes.length === 1) {
                this.inputs[7].value = sedes[0].value;
                this.inputs[8].data = await this.cursosDeSede(sedes[0].value);
            }
        },
        async loadInitial() {
            // await this.$API
            //     .get({
            //         url: "sedes",
            //         data: {}
            //     })
            //     .then(res => {
            //         this.inputs[7].data = res;
            //     });

            // this.$API
            //       .get({
            //         url: "cursos",
            //         data: {}
            //       })
            //       .then(res => {
            //         this.inputs[8].data = res;
            //       });

            let id = this.$route.params.id;
            if (this.$route.params.id) {
                await this.$API
                    .get({
                        url: "circuito/show/" + id,
                        data: {}
                    })
                    .then(res => {
                        if (res) {
                            console.log("este es la respuesta")
                            console.log(res)
                            this.inputs[7].data = res.sedes;
                            // console.log(this.inputs[9].data);
                            // debugger;
                            // this.inputs[9].data = [];
                            // let inicioMesesArr = [];

                            // if(res.suscripcion_id    != undefined) inicioMesesArr.push({ text: "Enero",      value: res.suscripcion_id    });
                            // if(res.suscripcion_id_2  != undefined) inicioMesesArr.push({ text: "Febrero",    value: res.suscripcion_id_2  });
                            // if(res.suscripcion_id_3  != undefined) inicioMesesArr.push({ text: "Marzo",      value: res.suscripcion_id_3  });
                            // if(res.suscripcion_id_4  != undefined) inicioMesesArr.push({ text: "Abril",      value: res.suscripcion_id_4  });
                            // if(res.suscripcion_id_5  != undefined) inicioMesesArr.push({ text: "Mayo",       value: res.suscripcion_id_5  });
                            // if(res.suscripcion_id_6  != undefined) inicioMesesArr.push({ text: "Junio",      value: res.suscripcion_id_6  });
                            // if(res.suscripcion_id_7  != undefined) inicioMesesArr.push({ text: "Julio",      value: res.suscripcion_id_7  });
                            // if(res.suscripcion_id_8  != undefined) inicioMesesArr.push({ text: "Agosto",     value: res.suscripcion_id_8  });
                            // if(res.suscripcion_id_9  != undefined) inicioMesesArr.push({ text: "Septiembre", value: res.suscripcion_id_9  });
                            // if(res.suscripcion_id_10 != undefined) inicioMesesArr.push({ text: "Octubre",    value: res.suscripcion_id_10 });
                            // if(res.suscripcion_id_11 != undefined) inicioMesesArr.push({ text: "Noviembre",  value: res.suscripcion_id_11 });
                            // if(res.suscripcion_id_12 != undefined) inicioMesesArr.push({ text: "Diciembre",  value: res.suscripcion_id_12 });

                            // this.inputs[9].data = inicioMesesArr; 

                            // this.inputs[9].data = res.fechaInicio && res.fechaInicio.length > 0 ? res.fechaInicio : "No aplica";
                            if(res.model){
                                if(res.model.circuito_interes!=null){
                                    if (parseInt(res.model.circuito_interes.sede_id) > 0) {
                                        this.inputs[7].value = parseInt(res.model.circuito_interes.sede_id);
                                        this.inputs[7].readonly = true;
                                        this.inputs[7].disabled = true;
                                        this.inputs[7].onchange = false;
                                        this.$API
                                            .get({
                                                url: "cursos-circuitos/" + parseInt(res.model.circuito_interes.sede_id),
                                                data: {}
                                            })
                                            .then(res => {
                                                this.inputs[8].data = res;
                                            });
                                    }
                                }
                                this.preseleccionar(res.sedes || []);
                            }else{
                                window.location.href = process.env.VUE_APP_SOPORTE_URL
                                
                            }

                        }else{
                            window.location.href = process.env.VUE_APP_SOPORTE_URL
                        }
                    });
            }
        },
        notificar() {
            this.loading = true;

            let app = this;

            app.$API
                .post({
                    url: "circuito/notificar-pago",
                    data: {
                        dni: (app.documentType == 1) ? app.dniPre : "P" + app.dniPre,
                        plataforma_pago: app.plataformaPre,
                        codigo_confirmacion: app.codigo_confirmacion
                    },
                })
                .then(res => {
                    app.loading = false;
                    app.first_step = false;
                    console.log(res);
                    app.paymentMessage = res.message;
                    app.dialog = true;

                    // this.$router.replace({ name: "CircuitoPago", params:{id:this.$route.params.id, idML:res.SecretKeyML} });
                    /*this.$store.dispatch("preinscrito", res.SecretKeyML);
                    setTimeout(() => {
                      this.$router.replace({ name: "CircuitoPago", params:{id:this.$route.params.id, idML:res.SecretKeyML} });
                    }, 2000);
                    */
                })
                .catch(fail => {
                    app.loading = false;
                    app.first_step = false;
                    console.log(fail);
                    app.paymentMessage = fail.message;
                    app.dialog = true;
                });
        },
    }
};
export default v;
</script>